import PropTypes from 'prop-types';
import { Chip, Typography } from '@mui/material';

const styles = {
  chip: ({ palette }) => ({
    paddingBlock: 1,
    width: 200,
    backgroundColor: palette.primary.main,
    '&:hover': {
      backgroundColor: palette.primary.main,
    },
    '.MuiChip-label': {
      paddingInline: 0,
    },
  }),
};

const ReportLink = ({ onClick }) => {
  return (
    <Chip
      onClick={onClick}
      label={
        <Typography variant="body2-bold" component="span" color="text.secondary">
          View Report
        </Typography>
      }
      sx={styles.chip}
    />
  );
};

ReportLink.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default ReportLink;
